export const bulkActivitySiteCoreKeys = {
  bulkActivityKey: "ProgramsAndParticipants.AddBulkActivity",
  //stepper keys
  bulkActivityStepperKey:
    "ProgramsAndParticipant.ParticipantAddBulkActivity.ProgressBarComponent",
  activityDetailsProgress:
    "ParticipantAddBulkActivity.ProgressBarComponent.ActivityDetailsProgressState",
  processingProgress:
    "ParticipantAddBulkActivity.ProgressBarComponent.ProcessingProgressState",
  processingYourRecordsMessage:
    "ParticipantAddBulkActivity.ProgressBarComponent.ProcessingYourRecordsMessage",
  participantProgress:
    "ParticipantAddBulkActivity.ProgressBarComponent.ParticipantProgressState",
  successProgress:
    "ParticipantAddBulkActivity.ProgressBarComponent.SuccessProgressState",
  letsStart: "ParticipantAddBulkActivity.ProgressBarComponent.LetsStart",
  almostThere: "ParticipantAddBulkActivity.ProgressBarComponent.AlmostThere",
  chooseParticipantMessage:
    "ParticipantAddBulkActivity.ProgressBarComponent.ChooseParticipantMessage",
  chooseMoreParticipantMessage:
    "ParticipantAddBulkActivity.ProgressBarComponent.ChooseMoreParticipantMessage",
  addParticipantActivitiesMessage:
    "ParticipantAddBulkActivity.ProgressBarComponent.AddParticipantsandActivitiesMessage",
  youAreDone: "ParticipantAddBulkActivity.ProgressBarComponent.YouareDone",
  addAdditionalBulkActivities:
    "ParticipantAddBulkActivity.ProgressBarComponent.AddAdditionalBulkActivities",
  greatYouareDone:
    "ParticipantAddBulkActivity.ProgressBarComponent.GreatYouareDone",
  unprocessedParticipantMessage:
    "ParticipantAddBulkActivity.ProgressBarComponent.UnprocessedParticipantMessage",
  addActivitiesMessage:
    "ParticipantAddBulkActivity.ProgressBarComponent.AddActivitiesMessage",
  processIcon: "ParticipantAddBulkActivity.ProgressBarComponent.ProcessIcon",

  //search participant form keys
  searchParticipantsKey:
    "ProgramsAndParticipant.ParticipantAddBulkActivity.SearchParticipants",
  participantName:
    "ParticipantAddBulkActivity.SearchParticipants.ParticipantName",
  client: "ParticipantAddBulkActivity.SearchParticipants.Client",
  coach: "ParticipantAddBulkActivity.SearchParticipants.Coach",
  createdDate: "ParticipantAddBulkActivity.SearchParticipants.CreatedDate",
  deliveryCountry:
    "ParticipantAddBulkActivity.SearchParticipants.DeliveryCountry",
  deliveryOffice:
    "ParticipantAddBulkActivity.SearchParticipants.DeliveryOffice",
  productLine: "ParticipantAddBulkActivity.SearchParticipants.ProductLine",
  programName: "ParticipantAddBulkActivity.SearchParticipants.ProgramName",
  programTemplate:
    "ParticipantAddBulkActivity.SearchParticipants.ProgramTemplate",
  status: "ParticipantAddBulkActivity.SearchParticipants.Status",
  filterByList: "ParticipantAddBulkActivity.SearchParticipants.FilterByList",
  filterByContains: "FilterBy.Contains",
  statusList: "ParticipantAddBulkActivity.SearchParticipants.StatusList",
  resetAllSearchWarningMessage:
    "ParticipantAddBulkActivity.SearchParticipants.ResetAllSearchWarningMessage",

  //search participant result keys
  searchParticipantsResultsKey:
    "ProgramsAndParticipant.ParticipantAddBulkActivity.SearchParticipantsResults",
  chooseParticipants:
    "ParticipantAddBulkActivity.SearchParticipantsResults.ChooseParticipants",
  resultClient: "ParticipantAddBulkActivity.SearchParticipantsResults.Client",
  resultParticipantName:
    "ParticipantAddBulkActivity.SearchParticipantsResults.ParticipantName",
  resultsProductLine:
    "ParticipantAddBulkActivity.SearchParticipantsResults.ProductLine",
  resultsProgramName:
    "ParticipantAddBulkActivity.SearchParticipantsResults.ProgramName",
  resultsProgramTemplate:
    "ParticipantAddBulkActivity.SearchParticipantsResults.ProgramTemplate",
  resultsSelected:
    "ParticipantAddBulkActivity.SearchParticipantsResults.Selected",
  resultsStatus: "ParticipantAddBulkActivity.SearchParticipantsResults.Status",
  resultsCreatedDate:
    "ParticipantAddBulkActivity.SearchParticipantsResults.CreatedDate",
  resultsDeliveryCountry:
    "ParticipantAddBulkActivity.SearchParticipantsResults.DeliveryCountry",
  resultsDeliveryOffice:
    "ParticipantAddBulkActivity.SearchParticipantsResults.DeliveryOffice",
  resultsCoach: "ParticipantAddBulkActivity.SearchParticipantsResults.Coach",
  resultsStatusList:
    "ParticipantAddBulkActivity.SearchParticipantsResults.StatusList",
  deliveryOfficeList:
    "ParticipantAddBulkActivity.SearchParticipantsResults.DeliveryOfficeList",
  atLeastSelectTwoParticipantsMessage:
    "ParticipantAddBulkActivity.SearchParticipantsResults.AtLeastSelectTwoParticipantsMessage",
  addParticipantsWarningMessage:
    "ParticipantAddBulkActivity.SearchParticipantsResults.AddParticipantsWarningMessage",
  participantsSelectedDropDownText:
    "ParticipantAddBulkActivity.SearchParticipantsResults.ParticipantsSectedDropDownText",
  atLeastSelectOneActivityMessage:
    "ParticipantAddBulkActivity.SearchParticipantsResults.AtLeastSelectOneActivityMessage",

  // activities details keys
  selectedParticipants:
    "ProgramsAndParticipant.ParticipantAddBulkActivity.SelectedParticipants",
  selectedParticipantsParticipantName:
    "ParticipantAddBulkActivity.SelectedParticipants.ParticipantName",
  selectedParticipantsProgramName:
    "ParticipantAddBulkActivity.SelectedParticipants.ProgramName",
  selectedParticipantsClient:
    "ParticipantAddBulkActivity.SelectedParticipants.Client",
  selectedParticipantsProgramTemplate:
    "ParticipantAddBulkActivity.SelectedParticipants.ProgramTemplate",
  selectedParticipantsStatus:
    "ParticipantAddBulkActivity.SelectedParticipants.Status",
  selectedParticipantsProductLine:
    "ParticipantAddBulkActivity.SelectedParticipants.ProductLine",
  selectedParticipantsCreatedDate:
    "ParticipantAddBulkActivity.SelectedParticipants.CreatedDate",
  deleteParticipantConfirmation:
    "ParticipantAddBulkActivity.SelectedParticipants.DeleteParticipantConfirmation",
  addParticipantLink:
    "ParticipantAddBulkActivity.SelectedParticipants.AddParticipantLink",
  actionHeader: "ParticipantAddBulkActivity.SelectedParticipants.Action",
  nextProgramClass:
    "ParticipantAddBulkActivity.SelectedParticipants.NextProgramClass",
  selectedParticipantsDeliveryCountry:
    "ParticipantAddBulkActivity.SelectedParticipants.DeliveryCountry",
  selectedParticipantsDeliveryOffice:
    "ParticipantAddBulkActivity.SelectedParticipants.DeliveryOffice",
  selectedParticipantsCoach:
    "ParticipantAddBulkActivity.SelectedParticipants.Coach",
  participantDeletedToastMessage:
    "ParticipantAddBulkActivity.SelectedParticipants.ParticipantDeletedToastMessage",
  atLeastSelectTwoParticipants:
    "ParticipantAddBulkActivity.SelectedParticipants.AtLeastSelectTwoParticipants",
  minimumTwoParticipantsRequired:
    "ParticipantAddBulkActivity.SelectedParticipants.MinimumTwoParticipantsRequired",
  bulkProcessDetails: "ProgramsAndParticipant.BulkProcess.BulkProcessDetails",
  bulkProcessNamePlaceholderText:
    "BulkProcess.BulkProcessDetails.BulkProcessNamePlaceholderText",
  bulkProcessName: "BulkProcess.BulkProcessDetails.BulkProcessName",
  addBulkActivityConfirmationText:
    "ParticipantActivity.ActivityTimeline.AddBulkActivityConfirmationText",
  serverErrorNotification:
    "ParticipantActivity.ActivityTimeline.UnexpectedServerErrorNotification",
  activityTimeLine:
    "ProgramsAndCandidates.ParticipantActivity.ActivityTimeline",
  somethingWentwrong: "ParticipantActivity.ActivityTimeline.SomethingWentWrong",

  //summaryDetails
  addBulkActivitySummary:
    "ProgramsAndCandidates.BulkParticipantSummary.ParticipantSummary",
  addBulkActivityLink:
    "BulkParticipantSummary.ParticipantSummary.AddBulkActivityLink",
  addBulkTransfer:
    "BulkParticipantSummary.ParticipantSummary.AddBulkTransferLink",
  imDoneButton: "BulkParticipantSummary.ParticipantSummary.IamDoneButton",
  numberOfActivity:
    "BulkParticipantSummary.ParticipantSummary.NumberofActivity",
  participantsProcessed:
    "BulkParticipantSummary.ParticipantSummary.ParticipantsProcessed",
  participantUnprocessed:
    "BulkParticipantSummary.ParticipantSummary.ParticipantsUnprocessed",
  totalNumberOfParticipant:
    "BulkParticipantSummary.ParticipantSummary.TotalNumberofParticipants",
  viewSummary: "BulkParticipantSummary.ParticipantSummary.ViewSummary",
  summaryTable:
    "ProgramsAndParticipant.ParticipantAddBulkActivity.BulkActivityParticipantSummaryTable",
  failureReason:
    "ParticipantAddBulkActivity.BulkActivityParticipantSummaryTable.FailureReason",
  processed:
    "ParticipantAddBulkActivity.BulkActivityParticipantSummaryTable.Processed-TableHeader",
  unProceseed:
    "ParticipantAddBulkActivity.BulkActivityParticipantSummaryTable.Unprocessed-TableHeader",
  smallImage: "SmallImage",
  tickImage:
    "ParticipantAddBulkActivity.BulkActivityParticipantSummaryTable.AddActivity-TickImage",
  addBulkActivitySuccessMessage:
    "BulkParticipantSummary.ParticipantSummary.AddBulkActivitySuccessMessage",
  bulkTransferParticipantsSuccessMessage:
    "BulkParticipantSummary.ParticipantSummary.BulkTransferParticipantsSuccessMessage",
  unProcessedParticipantsMessage:
    "BulkParticipantSummary.ParticipantSummary.UnProcessedParticipantsMessage",

  refreshStatusLink:
    "BulkParticipantSummary.ParticipantSummary.RefreshStatusLink",
  totalNumberOfRecords:
    "BulkParticipantSummary.ParticipantSummary.TotalNumberOfRecords",
  processedRecords:
    "BulkParticipantSummary.ParticipantSummary.ProcessedRecords",
  addNewBulkLink:
    "BulkParticipantSummary.ParticipantSummary.AddNewBulkActivityLink",
  yourParticipantRecordIsProcessingMessage:
    "BulkParticipantSummary.ParticipantSummary.YourParticipantRecordIsProcessingMessage",
  totalNumberOfProgramsIcon:
    "BulkParticipantSummary.ParticipantSummary.TotalNumberofProgramsIcon",
};
